import React from 'react';
import { motion } from 'framer-motion';
import { Ship, Anchor, Truck, FileText, CheckSquare, Settings, ShieldAlert, Hammer, HardHat, Building2, Trash2, Activity, Ruler, BadgeCheck, Gavel, FileSearch, Users, ClipboardCheck, Package } from 'lucide-react';
// FileCheck alias defined BEFORE usage in services array
const FileCheck = (props: any) => <ClipboardCheck {...props} data-id="element-189" />;
const services = [{
  name: 'Appraisals (Inland, Offshore, Yachts)',
  icon: FileText
}, {
  name: 'Cargo Load, Secure & Damage Surveys',
  icon: Package
}, {
  name: 'Cargo Container Damage & Condition',
  icon: Truck
}, {
  name: 'Trip & Tow / Towage Suitability',
  icon: Ship
}, {
  name: 'On & Off Charter Hire Surveys',
  icon: FileSearch
}, {
  name: 'Condition & Suitability Surveys',
  icon: CheckSquare
}, {
  name: 'Engine & Marine Gear Failure Analysis',
  icon: Settings
}, {
  name: 'Loss Prevention',
  icon: ShieldAlert
}, {
  name: 'New Vessel Construction Attendance',
  icon: Hammer
}, {
  name: 'Shipyard Repair Specs & Supervision',
  icon: HardHat
}, {
  name: 'Dock Builders Risk Surveys',
  icon: Building2
}, {
  name: 'Salvage Attendance / Cargo Disposal',
  icon: Trash2
}, {
  name: 'Hull Audio Gauging',
  icon: Activity
}, {
  name: 'Draft Surveys',
  icon: Ruler
}, {
  name: 'Marine Warranty Attendances',
  icon: BadgeCheck
}, {
  name: 'Expert Witness & Mediation',
  icon: Gavel
}, {
  name: 'AWO / ACC Audits',
  icon: FileCheck
}, {
  name: 'Collaborative Naval Architect Services',
  icon: Users
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-navy relative z-10" data-id="element-190">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <span className="text-accent font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-193">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase" data-id="element-194">
            Comprehensive Marine Solutions
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-4" data-id="element-195"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.4
        }} className="flex items-start p-4 bg-navy-light/30 border border-white/5 hover:bg-navy-light hover:border-accent/50 transition-all duration-300 group" data-id="element-197">
              <div className="flex-shrink-0 mr-4 mt-1" data-id="element-198">
                <service.icon className="w-6 h-6 text-accent group-hover:text-white transition-colors" data-id="element-199" />
              </div>
              <h3 className="text-white font-medium text-lg leading-snug group-hover:text-gray-100 transition-colors" data-id="element-200">
                {service.name}
              </h3>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-201">
          <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold uppercase tracking-wider text-white bg-accent hover:bg-red-700 transition-all duration-300 shadow-lg" data-id="element-202">
            Contact Us for Your Survey Needs
          </a>
        </div>
      </div>
    </section>;
}